<template>
  <div
    :class="{
      'bg-active-area': !customBackground,
      'bg-subtle': dropdownOpen,
      [customBackground]: customBackground,
    }"
    class="flex gap-2 items-center px-1.5 rounded-r-[6px] cursor-pointer">
    <IconWrapper
      v-if="selectedItems.length > 0 && clearable"
      icon="highlight_off"
      :size="small ? 20 : 24"
      @click.stop="emit('removeClicked')" />
    <IconWrapper
      icon="arrow_drop_down"
      :size="24"
      :class="[{ 'rotate-180': dropdownOpen }, 'duration-300']"
      type="round"
      @click="emit('arrowClicked')" />
  </div>
</template>

<script setup>
import IconWrapper from '../IconWrapper/IconWrapper.vue';

const props = defineProps({
  customBackground: String,
  selectedItems: Array,
  small: Boolean,
  clearable: Boolean,
  dropdownOpen: { type: Boolean, default: false },
});

const emit = defineEmits(['removeClicked', 'arrowClicked']);
</script>
